import { Action } from '@wix/component-protocol/schema';
import { IVirtualManifestBuilderProps } from '@wix/editor-platform-manifest-services';
import { CompRef } from '@wix/document-services-types';
import { BaseActionPanelAPI } from './BaseActionPanelAPI';
import { EditorPointer } from '@wix/editor-document-logic-api';

export class GenericActionPanelAPI extends BaseActionPanelAPI {
  constructor(
    readonly editorPointers: EditorPointer<CompRef>[],
    readonly action: Action,
    readonly actionName: string,
  ) {
    super();
  }

  getContent() {
    return undefined;
  }

  async getHostContext(props?: IVirtualManifestBuilderProps) {
    return this.getInfraSDKHostContext({
      ...props,
      editorPointers: props?.editorPointers ?? this.editorPointers,
    });
  }
}
